import React from 'react';
import { Text, Divider } from '@oneaudi/unified-web-components';
import { SYS_SPACE_FIXED_150 } from '@oneaudi/unified-web-common';
import { useServicesContext } from '../../../../../context';
import { renderReadonlyFieldForSummary } from './form-fieldsRethink';
import { RateWrapper } from './financeModal-stylesRethink';
import { useFinanceTranslations } from './finance-i18N';
export const FinanceSummaryWrapper = ({ formSummaryData, loading, }) => {
    var _a, _b, _c, _d, _e;
    if (!formSummaryData) {
        return null;
    }
    const audiContentService = useServicesContext().getAdditionalService('audi-content-service');
    const { fields } = audiContentService.getContent();
    const { includeRateInSummaryBreakdown } = fields;
    const i18n = useFinanceTranslations();
    const currency = (_c = (_b = (_a = useServicesContext()) === null || _a === void 0 ? void 0 : _a.getConfiguration()) === null || _b === void 0 ? void 0 : _b.currency) !== null && _c !== void 0 ? _c : (_e = (_d = useServicesContext()) === null || _d === void 0 ? void 0 : _d.audiMarketContextService) === null || _e === void 0 ? void 0 : _e.getContextItem('nemo.locale.currency');
    return (React.createElement(React.Fragment, null,
        formSummaryData.map((summaryData) => {
            return (React.createElement(React.Fragment, { key: `read-only-data-wrappper${summaryData.label}` },
                React.createElement(Text, { tag: "p", variant: { type: 'copy', order: '2', style: 'bold' }, key: `read-only-${summaryData.label}`, className: "default-color-text" }, summaryData.label),
                summaryData.detail.map((summary) => (React.createElement(React.Fragment, { key: `read-only-${summary.id}-wrapper` }, renderReadonlyFieldForSummary(summary, i18n, loading, currency))))));
        }),
        !includeRateInSummaryBreakdown &&
            formSummaryData.map((summaryData) => summaryData.detail
                .filter((item) => item.id === 'Rate')
                .map((summary) => (React.createElement(React.Fragment, { key: `rate-map-wrappper${summary.id}-rate` },
                React.createElement(Divider, { orientation: "horizontal", margin: [SYS_SPACE_FIXED_150, 0, SYS_SPACE_FIXED_150, 0] }),
                React.createElement(RateWrapper, null, renderReadonlyFieldForSummary(summary, i18n, loading, currency))))))));
};
